import React from "react";
import ReactDOM from "react-dom/client";

import { App } from "./App";
import "./styles.css";

// Office.js triggar Office.onReady när miljön är redo. Innan dess kan
// vi inte läsa mailItem eller anropa Office.auth.
Office.onReady(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
